import { ActionReducer, State } from '@ngrx/store';

/**
 * The reducers created by this class are not scoped by state. For scoped state,
 * create reducers by using Store Services.
 */
export abstract class BaseGlobalReducer {
  abstract createReducer(reducer: ActionReducer<State<any>>): ActionReducer<State<any>>;
}
